import React, { useMemo, useRef, useState, useEffect } from "react";
import { API_ENDPOINT } from "../../../services/api/resources";
import axios from "axios";
import {
  Box,
  Button,
  TextField,
  InputAdornment,
  Typography,
  Backdrop,
  CircularProgress,
  Alert,
  Fade,
  Autocomplete,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Skeleton,
} from "@mui/material";

import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ComparedTable from "../../../components/common/Comparison/ComparedTable";



const NewComparison = ({
  onBack,
  RFQCategory,
  setRFQCategory,
  user_token,
  selectedComparison,
}) => {
  const [comparisonData, setComparisonData] = useState([]);
  const [newcomparisonData, setNweComparisonData] = useState(null);
  const [rfqFile, setRfqFile] = useState(null);
  const [vendorFiles, setVendorFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [prnNumber, setPrnNumber] = useState("");
  const [categoryError, setCategoryError] = useState("");
  const [rfqOption, setRfqOption] = useState("upload"); // 'upload' or 'description'
  const [rfqDescription, setRfqDescription] = useState("");

  const tableRef = useRef(null);
  const rfqInputRef = useRef(null);
  const vendorInputRef = useRef(null);




  // console.log({ rfqData, vendorData })

  useEffect(() => {
    if (selectedComparison?.token) {
      const fetchComparisonDetail = async () => {
        try {
          const res = await axios.post(API_ENDPOINT.get_induvial_compare, {
            compare_token: selectedComparison.token,
          });
          console.log("Full response:", res);
          console.log("Data:", res.data);
          setComparisonData(res.data.result_json);
        } catch (err) {
          console.error("Error fetching comparison detail:", err);
        }
      };
      fetchComparisonDetail();
    }
  }, [selectedComparison]);

  const isViewMode = !!selectedComparison;


  console.log({
    selectedComparison,
    newcomparisonData,
    isViewMode,
    comparisonData
  })

  // Auto-scroll to table when comparison data is loaded
  useEffect(() => {
    if (comparisonData && comparisonData.length > 0 && tableRef.current) {
      setTimeout(() => {
        tableRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 300);
    }
  }, [comparisonData]);

  const handleRfqChange = (e) => setRfqFile(e.target.files[0]);
  const handleVendorChange = (e) => setVendorFiles(Array.from(e.target.files));

  const handleRfqDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files?.length) {
      setRfqFile(e.dataTransfer.files[0]);
      e.dataTransfer.clearData();
    }
  };

  const handleVendorDrop = (e) => {
    e.preventDefault();
    if (e.dataTransfer.files?.length) {
      setVendorFiles(Array.from(e.dataTransfer.files));
      e.dataTransfer.clearData();
    }
  };

  const handleDragOver = (e) => e.preventDefault();

  const handleBack = () => {
    setRfqFile(null);
    setVendorFiles([]);
    setError("");
    setComparisonData([]);
    setNweComparisonData(null);
    setRfqDescription("");
    if (onBack) onBack();
  };

  const handleSubmit = async () => {
    setError("");
    setCategoryError("");

    // Validation based on selected RFQ option
    if (rfqOption === "upload" && !rfqFile) {
      setError("Please upload RFQ file");
      return;
    }

    if (rfqOption === "description" && !rfqDescription.trim()) {
      setError("Please enter RFQ description");
      return;
    }

    if (vendorFiles.length === 0) {
      setError("Please upload at least one vendor file");
      return;
    }

    if (!prnNumber.trim()) {
      setError("Please enter Purchase Requisition Number");
      return;
    }

    if (!RFQCategory.id) {
      setCategoryError("RFQ category is required");
      setError("RFQ category is required");
      return;
    }

    if (newcomparisonData) {
      console.log("Using cached result:", comparisonData);
      return;
    }

    const formData = new FormData();

    if (rfqOption === "upload" && rfqFile) {
      formData.append("rfq", rfqFile);
    } else if (rfqOption === "description") {
      formData.append("rfq_text", rfqDescription);
    }

    vendorFiles.forEach((file) => formData.append("vendors", file));
    formData.append("prn_number", prnNumber);
    formData.append("category_id", RFQCategory.id);
    formData.append("user_token", user_token);

    try {
      setLoading(true);
      const res = await axios.post(API_ENDPOINT.compare_rfq_api, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log(res);
      const comp = res?.data?.data;

      setComparisonData(comp);
      setNweComparisonData(comp);
      setSuccess(true);
    } catch (error) {
      console.error("Error uploading files", error);
      setError("Failed to fetch comparison results");
    } finally {
      setLoading(false);
    }
  };

  /* -------------------- styles -------------------- */
  const boxStyle = {
    border: "2px dashed #cbd5e1",
    borderRadius: "8px",
    padding: "24px",
    width: "100%",
    maxWidth: "420px",
    textAlign: "center",
    position: "relative",
    marginTop: "1rem",
    height: "180px",
    background: "#f8fafc",
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: "#3b82f6",
      background: "#f0f7ff",
    },
  };

  return (
    <Box sx={{ p: 3 }}>
      {success && (
        <Alert
          severity="success"
          sx={{ mb: 2, borderRadius: 2 }}
          icon={<CheckCircleIcon fontSize="inherit" />}
        >
          Comparison completed successfully!
        </Alert>
      )}

      {error && (
        <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>
          {error}
        </Alert>
      )}

      <Button
        variant="outlined"
        size="large"
        onClick={handleBack}
        sx={{
          fontSize: 15,
          fontWeight: 600,
          textTransform: "none",
          px: 2.5,
          py: 1.2,
          borderRadius: 2,
          mb: 3,
        }}
      >
        Back
      </Button>

      {!isViewMode && (
        <Box>
          {/* Purchase Requisition Number and Quotation Category Row */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "flex-start",
              gap: 2,
              flexWrap: "wrap",
              mb: 3,
            }}
          >
            <Box sx={{ flex: 1, minWidth: 300 }}>
              <Typography
                sx={{
                  fontSize: 17,
                  fontWeight: 600,
                  mb: 1.5,
                  color: "#334155",
                }}
              >
                Purchase Requisition Number
              </Typography>
              <TextField
                fullWidth
                label="Enter Purchase Requisition Number"
                placeholder="Enter Purchase Requisition Number"
                value={prnNumber}
                onChange={(e) => setPrnNumber(e.target.value)}
                error={!prnNumber && error.includes("PRN number")}
                helperText={
                  !prnNumber && error.includes("PRN number")
                    ? "PRN number is required"
                    : ""
                }
                sx={{
                  "& .MuiOutlinedInput-root": { borderRadius: 2 },
                  "& input": { fontSize: 15, py: 1.2 },
                  "& label": { fontSize: 15 },
                }}
              />
            </Box>

            <Box sx={{ flex: 1, minWidth: 300 }}>
              <Typography
                sx={{
                  fontSize: 17,
                  fontWeight: 600,
                  mb: 1.5,
                  color: "#334155",
                }}
              >
                Quotation Category
              </Typography>
              <Autocomplete
                options={RFQCategory?.categoryList || []}
                getOptionLabel={(option) => option.category || ""}
                value={
                  RFQCategory?.categoryList.find(
                    (c) => c.id === RFQCategory.id
                  ) || null
                }
                onChange={(event, newValue) => {
                  setRFQCategory((prev) => ({
                    ...prev,
                    id: newValue ? newValue.id : "",
                    value: newValue ? newValue.category : "",
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Quotation Category"
                    placeholder="Choose a category"
                    error={!!categoryError}
                    sx={{
                      "& .MuiOutlinedInput-root": { borderRadius: 2 },
                      "& input": { fontSize: 15, py: 1.2 },
                      "& label": { fontSize: 15 },
                    }}
                  />
                )}
              />
            </Box>
          </Box>

          {/* RFQ Upload Section with Radio Buttons */}
          <Box
            sx={{
              mt: 3,
              display: "flex",
              flexWrap: "wrap",
              gap: 4,
              flexDirection: "column",
            }}
          >
            <Box sx={{ flex: 1, minWidth: 300 }}>
              <Typography
                sx={{
                  fontSize: 17,
                  fontWeight: 600,
                  mb: 1.5,
                  color: "#334155",
                }}
              >
                Upload RFQ/Requirement document
              </Typography>

              {/* Radio Button Selection */}
              <FormControl component="fieldset" sx={{ mb: 2 }}>
                <RadioGroup
                  row
                  value={rfqOption}
                  onChange={(e) => setRfqOption(e.target.value)}
                  sx={{ gap: 4 }} // slightly more spacing
                >
                  <FormControlLabel
                    value="upload"
                    control={<Radio sx={{ transform: "scale(1.2)" }} />} // slightly larger radio circle
                    label="File Upload"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "1.5rem",
                        fontWeight: 500,
                      },
                    }} // ⬅️ label styling
                  />
                  <FormControlLabel
                    value="description"
                    control={<Radio sx={{ transform: "scale(1.2)" }} />}
                    label="Enter Description"
                    sx={{
                      "& .MuiFormControlLabel-label": {
                        fontSize: "1.5rem",
                        fontWeight: 500,
                      },
                    }}
                  />
                </RadioGroup>
              </FormControl>

              {/* File Upload Section */}
              {rfqOption === "upload" && (
                <>
                  <Box
                    onDrop={handleRfqDrop}
                    onDragOver={handleDragOver}
                    sx={boxStyle}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        fontSize: 16,
                        color: "#334155",
                        mb: 0.5,
                      }}
                    >
                      Drag and drop file here
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{ color: "#64748b", fontSize: 14, mb: 2 }}
                    >
                      (Supported format xlsx, .xls, .csv)
                    </Typography>
                    <Button
                      variant="outlined"
                      size="medium"
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontSize: 14,
                        fontWeight: 500,
                        px: 2.5,
                      }}
                      onClick={() => rfqInputRef.current.click()}
                    >
                      Browse
                    </Button>
                    <input
                      type="file"
                      accept=".xlsx,.xls,.csv"
                      ref={rfqInputRef}
                      style={{ display: "none" }}
                      onChange={handleRfqChange}
                    />
                  </Box>

                  {rfqFile && (
                    <Box sx={{ mt: 1.5 }}>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => setRfqFile(null)}
                        sx={{
                          textTransform: "none",
                          fontSize: 13,
                          borderRadius: 2,
                          px: 1.5,
                          py: 0.5,
                          display: "inline-flex",
                          gap: 1,
                          borderColor: "#e2e8f0",
                          color: "#475569",
                        }}
                      >
                        <span
                          style={{
                            maxWidth: 220,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          title={rfqFile.name}
                        >
                          {rfqFile.name}
                        </span>
                        <DeleteForeverIcon
                          fontSize="small"
                          sx={{ color: "#ef4444" }}
                        />
                      </Button>
                    </Box>
                  )}
                </>
              )}

              {/* Description Input Section */}
              {rfqOption === "description" && (
                <Box
                  sx={{
                    ...boxStyle,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                  }}
                >
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    label="Enter Description"
                    placeholder="Enter your RFQ requirements description here..."
                    value={rfqDescription}
                    onChange={(e) => setRfqDescription(e.target.value)}
                    error={!rfqDescription && error.includes("RFQ description")}
                    helperText={
                      !rfqDescription && error.includes("RFQ description")
                        ? "Description is required"
                        : ""
                    }
                    sx={{
                      width: "100%",
                      maxWidth: "380px",
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 2,
                        height: "120px", // matches RFQ box height
                        alignItems: "flex-start",
                      },
                      "& textarea": {
                        fontSize: 15,
                        paddingTop: "12px",
                      },
                      "& label": { fontSize: 15 },
                    }}
                  />
                </Box>
              )}
            </Box>

            {/* Vendor Upload Section */}
            <Box sx={{ flex: 1, minWidth: 300 }}>
              <Typography
                sx={{
                  fontSize: 17,
                  fontWeight: 600,
                  mb: 1.5,
                  color: "#334155",
                }}
              >
                Supplier Quotation document
              </Typography>
              <Box
                onDrop={handleVendorDrop}
                onDragOver={handleDragOver}
                sx={boxStyle}
              >
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    fontSize: 16,
                    color: "#334155",
                    mb: 0.5,
                  }}
                >
                  Drag and drop files here
                </Typography>
                <Typography
                  variant="body2"
                  sx={{ color: "#64748b", fontSize: 14, mb: 2 }}
                >
                  (Supported: PDF, multiple files allowed)
                </Typography>
                <Button
                  variant="outlined"
                  size="medium"
                  sx={{
                    borderRadius: 2,
                    textTransform: "none",
                    fontSize: 14,
                    fontWeight: 500,
                    px: 2.5,
                  }}
                  onClick={() => vendorInputRef.current.click()}
                >
                  Browse Files
                </Button>
                <input
                  type="file"
                  accept=".pdf"
                  multiple
                  ref={vendorInputRef}
                  style={{ display: "none" }}
                  onChange={handleVendorChange}
                />
              </Box>

              {vendorFiles.length > 0 && (
                <Box
                  sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1.5 }}
                >
                  {vendorFiles.map((file, index) => (
                    <Button
                      key={`${file.name}-${index}`}
                      variant="outlined"
                      size="small"
                      onClick={() =>
                        setVendorFiles(
                          vendorFiles.filter((_, i) => i !== index)
                        )
                      }
                      sx={{
                        textTransform: "none",
                        fontSize: 13,
                        borderRadius: 2,
                        px: 1.5,
                        py: 0.5,
                        display: "inline-flex",
                        gap: 1,
                        maxWidth: 240,
                        borderColor: "#e2e8f0",
                        color: "#475569",
                      }}
                    >
                      <span
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        title={file.name}
                      >
                        {file.name}
                      </span>
                      <DeleteForeverIcon
                        fontSize="small"
                        sx={{ color: "#ef4444" }}
                      />
                    </Button>
                  ))}
                </Box>
              )}
            </Box>
          </Box>

          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSubmit()}
            disabled={
              loading ||
              (rfqOption === "upload" && !rfqFile) ||
              (rfqOption === "description" && !rfqDescription.trim()) ||
              vendorFiles.length === 0
            }
            sx={{
              mt: 4,
              height: 48,
              width: 200,
              fontWeight: 600,
              fontSize: 15,
              borderRadius: 2,
              boxShadow: "0 4px 12px rgba(59, 130, 246, 0.3)",
              "&:hover": {
                boxShadow: "0 6px 14px rgba(59, 130, 246, 0.4)",
              },
            }}
          >
            {loading ? "Comparing..." : "Compare Supplier Quotes"}
          </Button>
        </Box>
      )}

      {(newcomparisonData || (isViewMode && comparisonData?.datas?.length > 0)) && (
        <ComparedTable
          data={comparisonData}
          compareTitle={"Done"}
          compareJsonFile={comparisonData.datas}
          backButtonStatus={true}
          showHeader={true}
          isRefetchData={false}
          isLoading={false}
          handleRefetchData={() => console.log("Refresh triggered")}
          isAutoRefresh={false}
        />
      )}




      {/* Enhanced Loader */}
      <Backdrop
        open={loading}
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: "rgba(255, 255, 255, 0.9)",
        }}
      >
        <Fade in={loading} timeout={500}>
          <Box
            sx={{
              textAlign: "center",
              p: 4,
              borderRadius: 2,
              backgroundColor: "white",
              boxShadow: "0 10px 30px rgba(0, 0, 0, 0.15)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 2,
            }}
          >
            <CircularProgress
              size={60}
              thickness={4}
              sx={{ color: "#3b82f6" }}
            />
            <Typography
              variant="h6"
              sx={{
                fontWeight: 600,
                color: "#334155",
                mt: 1,
              }}
            >
              Comparing Documents
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: "#64748b",
                maxWidth: 300,
              }}
            >
              Analyzing and extracting data from your documents. This may take a
              moment...
            </Typography>
          </Box>
        </Fade>
      </Backdrop>
    </Box>
  );
};

export default NewComparison;
